import React from 'react';
import { LinearProgress } from '@mui/material';
import { withRouter } from 'react-router-dom';
import './NotificationFailureIndex.scss';
import moment from 'moment';
import { MomentDateFormat } from '../MomentDateFormat';
import { util } from '../Util';
import { ApiRoutes } from '../ApiRoutes';
import { FormLabel, PageHeading, PageWrap } from '../common/forms/FormElements';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentSlash } from '@fortawesome/free-solid-svg-icons';
import { Input, Row } from 'reactstrap';
import NotificationFailureResultTable from './NotificationFailureResultTable';

class NotificationFailureIndex extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            from: moment()
                .subtract(30, 'days')
                .format(MomentDateFormat.DateOnlyUTCHyphenated),
            to: '',
            searchText: '',
            loading: true,
            results: [],
            employees: [],
        };
    }

    componentDidMount() {
        return this.populateState();
    }

    handleFilterChange = (field) => (event) => {
        const value = event.target.value;

        this.setState({ [field]: value, loading: true }, this.populateState);
    };

    populateState = async () => {
        const { from, to, searchText } = this.state;

        const results = await util.fetch.andGetResponse(
            util.fetch.types.post,
            ApiRoutes.notificationFailure.search(),
            {
                from,
                to,
                searchText,
            }
        );

        this.setState({ results: results || [], loading: false });
    };

    render() {
        const { from, to, searchText, loading } = this.state;

        return (
            <PageWrap className="overflow-auto">
                <PageHeading>
                    <FontAwesomeIcon
                        icon={faCommentSlash}
                        className="mr-2 text-muted"
                    />
                    <span>Notification Failures</span>
                </PageHeading>
                <Row className="g-2">
                    <div className="col-12 col-sm-6 col-md-3">
                        <FormLabel
                            text="From"
                            htmlFor="notification-failure-from"
                        />
                        <Input
                            id="notification-failure-from"
                            type="date"
                            value={from}
                            onChange={this.handleFilterChange('from')}
                        />
                    </div>
                    <div className="col-12 col-sm-6 col-md-3">
                        <FormLabel
                            text="To"
                            htmlFor="notification-failure-to"
                        />
                        <Input
                            id="notification-failure-to"
                            type="date"
                            value={to}
                            onChange={this.handleFilterChange('to')}
                        />
                    </div>
                    <div className="col-12 col-md-6">
                        <FormLabel
                            text="Search Text"
                            htmlFor="notification-failure-search"
                        />
                        <Input
                            id="notification-failure-search"
                            type="text"
                            className="form-control"
                            value={searchText}
                            onChange={this.handleFilterChange('searchText')}
                            placeholder="Search destination, message, or error"
                        />
                    </div>
                </Row>
                {loading && (
                    <LinearProgress
                        className="mt-3"
                        variant="indeterminate"
                        color="secondary"
                    />
                )}

                <NotificationFailureResultTable {...this.state} />
            </PageWrap>
        );
    }
}

export default withRouter(NotificationFailureIndex);
